import React, {useContext,useEffect,useState} from 'react'
import { Box } from "@material-ui/core";
import Axios from 'axios'
import { UserGroupIcon, UserIcon } from '@heroicons/react/24/solid';
import { useContextoGlobal } from '../../../Context/contextoGlobal';
import { eventoContext } from '../contexto/EventoContext'
import { Button,Typography,Option, Select } from '@material-tailwind/react';
import { v4 as uuidv4 } from 'uuid';
import FilterOnIcon from '@mui/icons-material/FilterAlt';

export const ResumenCompleto = ({id_evento,setTitulo})=>{ // paso el listado por prop porque si lo traigo del contexto carga 2 veces ya que estaba en un useeffect del contexto la llamada a la api que trae los inscriptos ahora lo hago solo en el componente Listado y lo paso como prop
   // const {inscriptos} = useEventos()
    const [verDetalle,setVerDetalle] = useState(false)
    const [inscriptos,setInscriptos] = useState(false)
    const [cargando,setCargando] = useState(false)
    const { esCelular } = useContextoGlobal();
    const {setTestfiltro} = useContext(eventoContext)
    const [items,setItems] = useState([])
    const [newKey,setNewKey]=useState(0); // Hay algún problema con material tailwind y requiere un re renderizado cada vez que cambia el valor del select
    const [itemSeleccionado,setItemSeleccionado] = useState(null)
    const [idSeleccionado,setIdSeleccionado] = useState(null)
    const bkSelected = 'rgb(58 154 230 / 61%)'; 
    const bkNotSelected = 'rgb(58 154 230)';

    useEffect(()=>{
        cargarInscriptos()
    },[])

    useEffect(()=>{
        if(inscriptos?.inscriptos?.length){
                const items_inscriptos = new Set(inscriptos.inscriptos.map(item=>item.detalle)) 
                const items_inscriptos_array = Array.from(items_inscriptos)
                setItems(items_inscriptos_array)
        }
    },[inscriptos])

    useEffect(()=>{
        if(itemSeleccionado){
             cambioFiltro((item) => item?.detalle==itemSeleccionado,'select')
        }
    },[itemSeleccionado])

    const cambioFiltro = (callback,origen)=>{
        setTestfiltro(() => callback)
        if(!origen){
            setItemSeleccionado(null)
        }
   }

    const cargarInscriptos =  async (sinLoading)=>{
        
        if(!sinLoading){
            setCargando(true)
        }

        try{
            const {data} = await Axios.get(`/api/tablasgenerales/eventos/inscriptos/resumen/${id_evento}`)

            setInscriptos(data)
            setCargando(false)
        }catch(err){
           alert(err.response.data.message)
           setCargando(false)
        }
    }

    if (!inscriptos || !inscriptos.regiones){
        
        return null
    }

    return <Box> 
                <div className="text-center relative">
                    <div className={`grid ${esCelular ? 'grid-cols-1 space-y-2' : 'grid-cols-4 gap-2'}`}>
                                <div style={{background:idSeleccionado == 'inscriptos' ? bkSelected : ''}} 
                                    onClick={()=>{cambioFiltro((item) => item?.cod_interno);setIdSeleccionado('inscriptos');setTitulo('Todos los inscriptos')}} 
                                    title="Inscriptos" className="flex flex-col justify-center border-2 border-blue-400 rounded-lg py-2 px-10 cursor-pointer">
                                    <div className={`flex justify-center ${idSeleccionado == 'inscriptos' ? 'blink':''}`}>
                                        <UserGroupIcon width={25} />
                                    </div>
                                    <p className="text-small text-center" >Inscriptos</p>
                                    <p className="fw-700">{inscriptos.total}</p>
                                </div>
                                <div style={{background:idSeleccionado == 'presentes' ? bkSelected : ''}} 
                                    onClick={()=>{cambioFiltro((item) => item?.presente);setIdSeleccionado('presentes');setTitulo('Inscriptos ya ingresados al evento')}} 
                                    title="Ingresados" className="flex flex-col justify-center border-2 border-blue-400 rounded-lg py-2 px-10 cursor-pointer">
                                    <div className={`flex justify-center ${idSeleccionado == 'presentes' ? 'blink':''}`}>
                                        <UserGroupIcon width={25} />
                                    </div>
                                    <p className="text-small text-center" >Ingresados</p>
                                    <p className="fw-700">{inscriptos.inscriptos.filter(item=>item.presente==1).length}</p>
                                </div>
                                <div style={{background:idSeleccionado == 'UAD' ? bkSelected : ''}} 
                                    onClick={()=>{cambioFiltro((item) => item?.categoria === 'UAD');setIdSeleccionado('UAD');setTitulo('Inscriptos UAD')}} 
                                    title="Ministros UAD" className="flex flex-col justify-center border-2 border-blue-400 rounded-lg py-2 px-10 cursor-pointer">
                                    <div className={`flex justify-center ${idSeleccionado == 'UAD' ? 'blink':''}`}>
                                        <UserGroupIcon width={25} />
                                    </div>
                                    <p className="text-small text-center" >UAD</p>
                                    <p className="fw-700">{inscriptos.uad}</p>
                                </div>
                                <div style={{background:idSeleccionado == 'EXT' ? bkSelected : ''}} 
                                    onClick={()=>{cambioFiltro((item) => item?.categoria === 'EXT');setIdSeleccionado('EXT');setTitulo('Inscriptos externos')}} 
                                    title="Participantes externos" className="flex flex-col justify-center border-2 border-blue-400 rounded-lg py-2 px-10 cursor-pointer">
                                    <div className={`flex justify-center ${idSeleccionado == 'EXT' ? 'blink':''}`}>
                                        <UserGroupIcon width={25} />
                                    </div>
                                    <p className="text-small text-center" >Externos</p>
                                    <p className="fw-700">{inscriptos.externos}</p>
                                </div>
                                <div style={{background:idSeleccionado == 'matrimonios' ? bkSelected : ''}} 
                                    onClick={()=>{cambioFiltro((item) => item?.tarif_matr);setIdSeleccionado('matrimonios');setTitulo('Inscriptos por matrimonio')}} 
                                    title="Matrimonios" className="flex flex-col justify-center border-2 border-blue-400 rounded-lg py-2 px-10 cursor-pointer">
                                    <div className={`flex justify-center ${idSeleccionado == 'matrimonios' ? 'blink':''}`}>
                                        <UserGroupIcon width={25} />
                                    </div>
                                    <p className="text-small text-center" >Matrimonios</p>
                                    <p className="fw-700">{inscriptos.matrimonios}</p>
                                </div>
                                <div style={{background:idSeleccionado == 'individuos' ? bkSelected : ''}} 
                                    onClick={()=>{cambioFiltro((item) => !(item?.tarif_matr));setIdSeleccionado('individuos');setTitulo('Inscriptos individuales')}} 
                                    title="Individuos" className="flex flex-col justify-center border-2 border-blue-400 rounded-lg py-2 px-10 cursor-pointer">
                                    <div className={`flex justify-center ${idSeleccionado == 'individuos' ? 'blink':''}`}>
                                        <UserGroupIcon width={25} />
                                    </div>
                                    <p className="text-small text-center" >Individuos</p>
                                    <p className="fw-700">{inscriptos.individuos}</p>
                                </div>
                                <div style={{background:idSeleccionado == 'menores' ? bkSelected : ''}} 
                                    onClick={()=>{cambioFiltro((item) => Number((item?.edad || 0))<13);setIdSeleccionado('menores');setTitulo('Menores de 13 años')}} 
                                    title="Menores de 18 años" className="flex flex-col justify-center border-2 border-blue-400 rounded-lg py-2 px-10 cursor-pointer">
                                    <div className={`flex justify-center ${idSeleccionado == 'menores' ? 'blink':''}`}>
                                        <UserGroupIcon width={25} />
                                    </div>
                                    <p className="text-small text-center" >Menores</p>
                                    <p className="fw-700">{inscriptos.menores}</p>
                                </div>
                                <div style={{background:idSeleccionado == 'mayores' ? bkSelected : ''}} 
                                    onClick={()=>{cambioFiltro((item) => Number((item?.edad || 0))>12);setIdSeleccionado('mayores');setTitulo('Mayores de 12 años')}} 
                                    title="Mayores de 17 años" className="flex flex-col justify-center border-2 border-blue-400 rounded-lg py-2 px-10 cursor-pointer">
                                    <div className={`flex justify-center ${idSeleccionado == 'mayores' ? 'blink':''}`}>
                                        <UserGroupIcon width={25} />
                                    </div>
                                    <p className="text-small text-center" >Mayores</p>
                                    <p className="fw-700">{inscriptos.mayores}</p>
                                </div>
                               
                    </div>
                    {!verDetalle && <Button title='Ver más información' style={{marginTop:'1.5rem'}} onClick={()=>setVerDetalle(true)} color='primary' variant='text' className='text-red-400 bg-red-100 hover:bg-red-200'>Ver más datos</Button>}
                    {verDetalle && <TT inscriptos={inscriptos} setVerDetalle={setVerDetalle}/>}
                    <Box style={{background:idSeleccionado == 'itemEvento' ? bkSelected : ''}} sx={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',marginTop:'1.5rem'}}>
                        <Select 
                            label="Item del evento:" 
                            value={itemSeleccionado || 'seleccione'}	
                            key={newKey} // Hay algún problema con material tailwind y requiere un re renderizado cada vez que cambia el valor del select
                            onChange={(e)=>{
                                setItemSeleccionado(e)
                                setIdSeleccionado('itemEvento')
                                setNewKey(uuidv4())
                                setTitulo(`Inscriptos a: ${e}`)
                            }}
                        >
                            {items.map((item) => (
                                <Option key={uuidv4()} value={item}>
                                        {item?.toUpperCase()}
                                </Option>
                            ))}
                        </Select>
                    </Box>
                </div>
        </Box>
            
}
//                    <Typography variant='body2'>{item[0]!='' ? regiones ? `Región ${item[0]}: ` : `${item[0]}: ` : 'S/R: '} <b>{item[1]}</b></Typography>


const TT = ({inscriptos, setVerDetalle})=>{

     return <div>
        
            <Button title='Ver menos información' style={{marginTop:'1.5rem'}} onClick={()=>setVerDetalle(false)} color='primary'variant='text' className='text-red-400 bg-red-100 hover:bg-red-200'>Ver menos datos</Button>
        <div className="flex justify-center mt-4 mb-4">
        <table className="mr-4">
            <tbody>
            {inscriptos.rangos.filter(item=>item[0]!='').map(item=><tr className={`a-psts-c5`}>
                {/*<td className="text-xsmall text-left" >{rango.nombre.substring(2, rango.nombre.lenght)}</td>*/}
                <td className="text-small text-left p-2" >{item[0]=='' ? 'S/R' : item[0]}</td>
                <td className="pl-4 pr-4"> <span className="fw-700">{item[1]}</span></td>
                </tr>)}
            </tbody>
        </table>
        <div className="grid grid-cols-3 gap-2 items-center">
            {inscriptos.regiones.filter(item=>item[0]!='').map(item=><div className={`a-psts-c5`}>
                <p className="text-small text-left p-2" >R-{item[0]=='' ? '?' : item[0]} <span className="ml-2 fw-700">({item[1]})</span></p>
            </div>)}
        </div>
    </div>
 </div>
}

const TTold = ({inscriptos})=>{
    return <div className="flex justify-center mt-4 mb-4">
    <table className="table3 mr-4">
        <tbody>
        {[{nombre:'rango1',iniciales:'iniciales'}].map(rango=><tr className={`a-psts-c5`}>
            {/*<td className="text-xsmall text-left" >{rango.nombre.substring(2, rango.nombre.lenght)}</td>*/}
            <td className="text-left a-col1" >{rango.nombre.substring(2, rango.nombre.lenght)}</td>
            <td className="text-xsmall text-left a-col0" >{rango.iniciales}</td>
            <td className="pl-4 pr-4"> <span className="fw-700">250</span></td>
            </tr>)}
        </tbody>
    </table>
    <div className="flex f-col justify-content-space-evenly ml-2">
        {[{id_region:1}].map(region=><div className={`a-psts-c5`}>
            <p className="text-small text-left p-2" >R-{region.id_region} <span className="ml-2 fw-700">300</span></p>
            </div>)}
    </div>
</div>
}